import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName } from "../../helper/common";
import styles from "./TenantGreeting.module.css";

const TenantGreeting = ({ user, isGuarantor = false }) => {
  const { _t } = useTranslator();
  const name = getUserDisplayName(user, "").split(" ")[0] || user?.fname || "";
  const guarantorFor = Array.isArray(user?.gurantor_for)
    ? user.gurantor_for
        .map(
          (tenant) =>
            getUserDisplayName(tenant, "") ||
            tenant?.email ||
            tenant?.fname ||
            ""
        )
        .filter(Boolean)
    : [];

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>
        {isGuarantor
          ? _t("guarantorFor", "Guarantor for")
          : _t(
              "hiNameHeresYourSkorProfile",
              `Hi ${name}, here's your Skor profile`,
              undefined,
              { name }
            )}
      </h1>
      {isGuarantor && guarantorFor.length > 0 && (
        <p className={styles.sub}>{guarantorFor.join(", ")}</p>
      )}
    </div>
  );
};

export default TenantGreeting;
